import React from 'react'
import PropTypes from 'prop-types'
import { Link, Redirect, Switch, withRouter } from 'react-router-dom'
import { Button } from 'reactstrap'
import { ProtectedRoute } from '../helpers/ProtectedRoute'
import MarketplaceHome from '../components/marketplace/owner/MarketplaceHome'
import MarketplaceServiceDetail from '../components/marketplace/owner/MarketplaceServiceDetail'
import ServiceRequestsList from '../components/marketplace/requests/ServiceRequestsList'
import ServiceRequestConversation from '../components/marketplace/requests/ServiceRequestConversation'

const REQUESTS_PATH = '/dashboard/marketplace/requests'

const OwnerRequests = () => (
  <ServiceRequestsList
    side="owner"
    basePath={REQUESTS_PATH}
    emptyAction={
      <Button tag={Link} to="/dashboard/marketplace" color="primary" size="sm">
        Explorar el Marketplace
      </Button>
    }
  />
)

const OwnerConversation = () => <ServiceRequestConversation side="owner" listPath={REQUESTS_PATH} />

const MarketplaceRoutes = ({ match: { url } }) => (
  <Switch>
    <ProtectedRoute exact path={`${url}`} rols={['property']} component={MarketplaceHome} />
    <ProtectedRoute exact path={`${url}/services/:id(\\d+)`} rols={['property']} component={MarketplaceServiceDetail} />
    <ProtectedRoute exact path={`${url}/requests`} rols={['property']} component={OwnerRequests} />
    <ProtectedRoute exact path={`${url}/requests/:id(\\d+)`} rols={['property']} component={OwnerConversation} />
    <Redirect to="/errors/404" />
  </Switch>
)

MarketplaceRoutes.propTypes = { match: PropTypes.object.isRequired }

export default withRouter(MarketplaceRoutes)
